import { Box, Button, Chip, Grid, Pagination, Paper, Skeleton, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useLang } from '../../../../language';
import { InputText } from '../../../../components/Inputs/InputText';
import { NoticiasServices } from '../../controllers/services/noticias.services';
import { ActividadesServices } from '../../controllers/services/actividades.services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faCheckCircle, faEye, faGraduationCap, faMapMarkerAlt, faNewspaper, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router';
import { PersonasServices } from '../../controllers/services/personas.services';
import { ModalStatusServer } from '../../../../components/ModalStatus/ModalStatusServer';
import { ModalNoticia } from './ModalNoticia';
import { ModalActividad } from './ModalActividad';

export const Inici = ({ setBreadcrumbLineItems, route, empresa }: any) => {

    const Lang = useLang()

    const [noticiaSeleccionada, setNoticiaSeleccionada] = useState<any>(null)

    const [actividadSeleccionada, setActividadSeleccionada] = useState<any>(null)

    const [filtroActividades, setFiltroActividades] = useState('')

    // Marca el primer render: la carga inicial la hace el efecto de montaje y el
    // debounce se salta su primera ejecución para no duplicar la petición.
    const primeraCargaActividades = useRef(true)

    // Página seleccionada de cada listado: se mantiene en estado local para que
    // quede marcada mientras el WS responde (durante la carga `data` vuelve a null).
    const [paginacionActividadesView, setPaginacionActividadesView] = useState({ page: 1, last_page: 1 })

    const [paginacionNoticiasView, setPaginacionNoticiasView] = useState({ page: 1, last_page: 1 })

    // Notícies del WS d'Activitats (integraWeb.php accion=obtener_noticias)
    const [fetchNoticiasGET, fetchNoticiasGETData] = NoticiasServices.GET_NOTICIAS()

    const [fetchNoticiaGET, fetchNoticiaGETData, resetNoticiaGET] = NoticiasServices.GET_NOTICIA()

    const noticias = fetchNoticiasGETData.data?.items || []

    const noticiasCargando = !!fetchNoticiasGETData.loading

    // Activitats del WS d'Activitats (integraWeb.php accion=obtener_actividades_disponibles)
    const [fetchActividadesGET, fetchActividadesGETData] = ActividadesServices.GET_ACTIVIDADES()

    const actividades = fetchActividadesGETData.data?.items || []

    const actividadesCargando = !!fetchActividadesGETData.loading

    const actividadesError = fetchActividadesGETData.error

    const [fetchActividadGET, fetchActividadGETData, resetActividadGET] = ActividadesServices.GET_ACTIVIDAD()

    const { empresaId } = useParams()

    // Personas de la empresa (API Laravel) para seleccionar quién se inscribe en la actividad
    const [personasPage, setPersonasPage] = useState(1)
    const [personasBuscar, setPersonasBuscar] = useState('')
    const [checkedPersonas, setCheckedPersonas] = useState<Set<number>>(new Set())

    const [fetchPersonasGET, fetchPersonasGETData, resetPersonasGET] = PersonasServices.GET_DISPONIBLES()

    const [fetchInscribirPOST, fetchInscribirPOSTData] = ActividadesServices.POST_INSCRIBIR_PERSONAS()

    const [fetchAnularPOST, fetchAnularPOSTData] = ActividadesServices.ANULAR_INSCRIPCION()

    // Clave común entre la persona del backoffice y el `clientes` del WS d'Activitats
    const normalizaNif = (nif: any) => String(nif || '').trim().toUpperCase()

    useEffect(() => {

        setBreadcrumbLineItems((item: any) => [...item.slice(0, 2), route])

    }, [])

    useEffect(() => {

        // GET {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php?accion=obtener_noticias&no_seccion=700
        fetchNoticiasGET({ page: 1 })

    }, [])

    // Carga inicial inmediata de actividades: la primera petición no debe esperar
    // al debounce del buscador (evita el retardo antes de que aparezca el skeleton).
    useEffect(() => {

        fetchActividadesGET({ actividad: '', page: 1 })

    }, [])

    // Sincroniza la página seleccionada con la respuesta del WS (activitats + notícies)
    useEffect(() => {

        const paginacionActividades = fetchActividadesGETData.data?.paginacion
        const paginacionNoticias = fetchNoticiasGETData.data?.paginacion

        if (paginacionActividades?.page != null) {

            // `Number()`: el WS devuelve `current_page` como string; MUI compara
            // `page` con `===` estricto y sin coerción se desmarcaría el botón.
            setPaginacionActividadesView({
                page: Number(paginacionActividades.page),
                last_page: Number(paginacionActividades.last_page || paginacionActividades.page),
            })
        }

        if (paginacionNoticias?.page != null) {

            setPaginacionNoticiasView({
                page: Number(paginacionNoticias.page),
                last_page: Number(paginacionNoticias.last_page || paginacionNoticias.page),
            })
        }

    }, [fetchActividadesGETData.data, fetchNoticiasGETData.data])

    // Búsqueda de actividades con debounce: se llama al WS con `actividad` y `page`
    useEffect(() => {

        if (primeraCargaActividades.current) {

            primeraCargaActividades.current = false
            return
        }

        const handler = setTimeout(() => {

            setPaginacionActividadesView((prev: any) => ({ ...prev, page: 1 }))

            fetchActividadesGET({ actividad: filtroActividades.trim(), page: 1 })
        }, 400)

        return () => clearTimeout(handler)

    }, [filtroActividades])

    const handleCambioPaginaActividades = (event: any, nuevaPagina: number) => {

        setPaginacionActividadesView((prev: any) => ({ ...prev, page: nuevaPagina }))

        fetchActividadesGET({ actividad: filtroActividades.trim(), page: nuevaPagina })
    }

    const handleCambioPaginaNoticias = (event: any, nuevaPagina: number) => {

        setPaginacionNoticiasView((prev: any) => ({ ...prev, page: nuevaPagina }))

        fetchNoticiasGET({ page: nuevaPagina })
    }

    const handleVerNoticia = (noticia: any) => {

        setNoticiaSeleccionada(noticia)

        // GET .../integraWeb.php?accion=obtener_noticias&no_id_noticia=N (contenido completo del modal)
        fetchNoticiaGET({ no_id_noticia: noticia.id })
    }

    const handleCerrarNoticia = () => {

        setNoticiaSeleccionada(null)
        resetNoticiaGET()
    }

    const handleVerActividad = (actividad: any) => {

        setActividadSeleccionada(actividad)

        // GET .../integraWeb.php?accion=obtener_detalle_actividad&id=N&cif=... (contenido completo del modal)
        fetchActividadGET({ id: actividad.id, cif: empresa?.cif })
    }

    const handleCerrarActividad = () => {

        setActividadSeleccionada(null)
        resetActividadGET()
        resetPersonasGET()
        setCheckedPersonas(new Set())
    }

    // Al abrir el detalle de una actividad se carga el listado de personas de la
    // empresa (API Laravel, mismo endpoint que el módulo Personas) para poder
    // seleccionar quién se inscribe.
    useEffect(() => {

        if (!actividadSeleccionada) return

        setPersonasPage(1)
        setPersonasBuscar('')

        if (empresaId) {

            fetchPersonasGET({
                params: {
                    empresa_id: Number(empresaId),
                    page: 1,
                    per_page: 10,
                    estado: 'autorizada',
                }
            })
        }

    }, [actividadSeleccionada?.id])

    // Mantiene marcadas las personas ya inscritas (se comparan por NIF)
    useEffect(() => {

        const inscritos = (fetchActividadGETData.data?.inscritos || [])
            .filter((ins: any) => String(ins.in_estado) !== '109')

        if (!actividadSeleccionada || inscritos.length === 0) return

        const nifsInscritos = new Set(inscritos.map((ins: any) => normalizaNif(ins.nif)))

        setCheckedPersonas((prev) => {

            const nuevo = new Set(prev)

            ;(fetchPersonasGETData.data?.items || []).forEach((p: any) => {

                if (nifsInscritos.has(normalizaNif(p.nif))) nuevo.add(p.id)
            })

            return nuevo
        })

    }, [fetchActividadGETData.data?.inscritos, fetchPersonasGETData.data?.items])

    const handleCambioPaginaPersonas = (event: any, nuevaPagina: number) => {

        setPersonasPage(nuevaPagina)

        fetchPersonasGET({
            params: {
                empresa_id: Number(empresaId),
                page: nuevaPagina,
                per_page: 10,
                search: personasBuscar || undefined,
                estado: 'autorizada',
            }
        })
    }

    const handleBuscarPersonas = (texto: string) => {

        setPersonasBuscar(texto.trim())
        setPersonasPage(1)

        fetchPersonasGET({
            params: {
                empresa_id: Number(empresaId),
                page: 1,
                per_page: 10,
                search: texto.trim() || undefined,
                estado: 'autorizada',
            }
        })
    }

    const handleTogglePersona = (persona: any) => {

        setCheckedPersonas((prev) => {

            const nuevo = new Set(prev)

            if (nuevo.has(persona.id)) nuevo.delete(persona.id)
            else nuevo.add(persona.id)

            return nuevo
        })
    }

    // Personas marcadas en la página actual (ya inscritas + recién seleccionadas)
    const personasMarcadas = (fetchPersonasGETData.data?.items || [])
        .filter((p: any) => checkedPersonas.has(p.id))
        .map((p: any) => p)

    const handleInscribirPersonas = () => {

        if (!actividadSeleccionada?.id) return

        // Inscripciones activas (se ignoran las anuladas, in_estado '109')
        const inscritos = (fetchActividadGETData.data?.inscritos || [])
            .filter((ins: any) => String(ins.in_estado) !== '109')

        const nifsInscritos = new Set(inscritos.map((ins: any) => normalizaNif(ins.nif)))

        // Solo se envían las seleccionadas que NO están ya inscritas (evita duplicar)
        const nuevas = personasMarcadas.filter((p: any) => !nifsInscritos.has(normalizaNif(p.nif)))

        if (nuevas.length === 0) return

        // POST {WS}/integraWeb.php  accion=inscribir_personas_actividad (body JSON)
        // Se envía el objeto `raw` que devuelve /empresas/consultar/{id} (con los
        // datos de la persona física) para que el WS pueda registrar o actualizar
        // el cliente (`clientes`) vinculado a la actividad.
        //
        // De cada persona se manda el objeto `persona_fisica` completo del listado
        // paginado, no solo el NIF: el WS lo necesita para dar de alta o actualizar
        // el `clientes` de la persona igual que hace con la empresa. Viene siempre
        // porque el listado hace un INNER JOIN con `integra_personas_fisicas`.
        fetchInscribirPOST({
            empresa_id: Number(empresaId),
            cif: empresa?.cif,
            empresa: empresa?.raw || {},
            actividad_id: actividadSeleccionada.id,
            personas: nuevas.map((p: any) => p.persona_fisica),
        })
    }

    const handleAnularInscripcion = (ins: any) => {

        if (!ins?.id) return

        // POST {WS}/integraWeb.php  accion=anular_inscripcion (body JSON)
        fetchAnularPOST({ id: ins.id })
    }

    useEffect(() => {

        if (String(fetchInscribirPOSTData.status)?.[0] === '2') {

            // Refresca el detalle para actualizar los inscritos y los pre-checks
            if (actividadSeleccionada?.id) fetchActividadGET({ id: actividadSeleccionada.id, cif: empresa?.cif })
        }

    }, [fetchInscribirPOSTData])

    useEffect(() => {

        if (String(fetchAnularPOSTData.status)?.[0] === '2') {

            // Refresca el detalle para actualizar los inscritos tras anular
            if (actividadSeleccionada?.id) fetchActividadGET({ id: actividadSeleccionada.id, cif: empresa?.cif })
        }

    }, [fetchAnularPOSTData])

    return (
        <div>

            <Grid container spacing={2}>

                {/* -------------------- Activitats disponibles -------------------- */}

                <Grid item xs={12} lg={7}>
                    <Paper className='p-3 p-md-4 h-100' sx={{ borderRadius: 2.5 }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} className='mb-2'>
                            <FontAwesomeIcon icon={faGraduationCap} className='color-primary' />
                            <Typography variant='h6' className='my-0 fw-500 color-primary'>
                                {Lang('ACTIVITATS_DISPONIBLES')}
                            </Typography>
                        </Box>

                        <Box className='mb-2'>
                            <InputText
                                label={Lang('BUSCAR_ACTIVIDAD')}
                                name='buscarActividad'
                                value={filtroActividades}
                                onChange={(e: any) => setFiltroActividades(e.target.value)}
                            />
                        </Box>

                        {
                            actividadesCargando &&
                            <Grid container spacing={1.5} className='mb-2'>
                                {
                                    [0, 1, 2, 3].map((indice: number) => (
                                        <Grid item xs={12} sm={6} key={indice} sx={{ display: 'flex' }}>
                                            <Paper variant="outlined" className='h-100' sx={{ width: '100%', p: 1.5, borderRadius: 2 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                                                    <Skeleton variant="text" width="60%" sx={{ fontSize: '1rem' }} />
                                                    <Skeleton variant="rounded" width={48} height={22} />
                                                </Box>
                                                <Skeleton variant="text" sx={{ fontSize: '0.8rem', mt: 1 }} />
                                                <Skeleton variant="text" width="70%" sx={{ fontSize: '0.8rem' }} />
                                                <Skeleton variant="text" width={110} height={30} sx={{ mt: 1 }} />
                                            </Paper>
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        }

                        {
                            !actividadesCargando && actividadesError &&
                            <Typography variant='caption' className='my-0 mb-2' sx={{ color: 'error.main', display: 'block', textAlign: 'center' }}>
                                {String(actividadesError?.message || actividadesError)}
                            </Typography>
                        }

                        <Grid container spacing={1.5}>

                            {
                                fetchActividadesGETData.loading === false && !actividadesError && actividades.length === 0 && filtroActividades.trim() !== '' &&
                                <Grid item xs={12}>
                                    <Typography variant='body2' className='my-0' sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                                        {Lang('SENSE_ACTIVITATS')}
                                    </Typography>
                                </Grid>
                            }

                            {
                                actividades.map((actividad: any) => (
                                    <Grid item xs={12} sm={6} key={actividad.id} sx={{ display: 'flex' }}>
                                        <Paper
                                            variant="outlined"
                                            className='h-100'
                                            sx={{
                                                width: '100%',
                                                p: 1.5,
                                                borderRadius: 2,
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: 2,
                                                    transform: 'translateY(-2px)',
                                                },
                                            }}
                                        >

                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                                                <Typography variant='subtitle2' className='fw-500 my-0' sx={{ wordBreak: 'break-word', minWidth: 0 }}>
                                                    {actividad.titulo}
                                                </Typography>
                                                <Chip
                                                    label={actividad.tipo}
                                                    size="small"
                                                    color="primary"
                                                    variant="outlined"
                                                />
                                            </Box>

                                            <Box className='mt-2' sx={{ display: 'grid', gap: 0.5 }}>
                                                <Typography variant='body2' className='my-0' sx={{ color: 'text.secondary' }}>
                                                    <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 6, fontSize: 12 }} />
                                                    {Lang('DATA')}: {actividad.fecha}
                                                </Typography>

                                                <Typography variant='body2' className='my-0' sx={{ color: 'text.secondary' }}>
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: 6, fontSize: 12 }} />
                                                    {Lang('LLOC')}: {actividad.lugar}
                                                </Typography>
                                            </Box>

                                            <Button
                                                size="small"
                                                color="primary"
                                                variant="text"
                                                className='mt-2'
                                                startIcon={<FontAwesomeIcon icon={faEye} />}
                                                onClick={() => handleVerActividad(actividad)}
                                            >
                                                {Lang('MES_INFORMACIO')}
                                            </Button>

                                        </Paper>
                                    </Grid>
                                ))
                            }

                        </Grid>

                        {
                            fetchActividadesGETData.loading !== null && (actividades.length > 0 || fetchActividadesGETData.loading === true) &&
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, flexWrap: 'wrap', gap: 1 }}>
                                <Typography variant='caption' className='my-0' sx={{ color: 'text.secondary' }}>
                                    {paginacionActividadesView.page} de {paginacionActividadesView.last_page}
                                </Typography>
                                {
                                    paginacionActividadesView.last_page > 1 &&
                                    <Pagination
                                        page={paginacionActividadesView.page}
                                        count={paginacionActividadesView.last_page}
                                        onChange={handleCambioPaginaActividades}
                                        color="primary"
                                        size="small"
                                    />
                                }
                            </Box>
                        }

                    </Paper>
                </Grid>

                {/* -------------------- Notícies -------------------- */}

                <Grid item xs={12} lg={5}>
                    <Paper className='p-3 p-md-4 h-100' sx={{ borderRadius: 2.5 }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} className='mb-3'>
                            <FontAwesomeIcon icon={faNewspaper} className='color-primary' />
                            <Typography variant='h6' className='my-0 fw-500 color-primary'>
                                {Lang('NOTICIAS')}
                            </Typography>
                        </Box>

                        {
                            noticiasCargando &&
                            <Box sx={{ display: 'grid', gap: 1 }} className='mb-2'>
                                {
                                    [0, 1].map((indice: number) => (
                                        <Paper key={indice} variant="outlined" className='p-2' sx={{ borderRadius: 2 }}>
                                            <Skeleton variant="rectangular" height={220} sx={{ borderRadius: 1.5, mb: 1.5, bgcolor: 'grey.100' }} />
                                            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                            <Skeleton variant="text" width="40%" sx={{ fontSize: '0.75rem' }} />
                                            <Skeleton variant="text" sx={{ fontSize: '0.8rem' }} />
                                            <Skeleton variant="text" width="80%" sx={{ fontSize: '0.8rem' }} />
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Skeleton variant="text" width={90} sx={{ display: 'inline-block' }} />
                                            </Box>
                                        </Paper>
                                    ))
                                }
                            </Box>
                        }

                        {
                            !noticiasCargando && fetchNoticiasGETData.error &&
                            <Typography variant='caption' className='my-0 mb-2' sx={{ color: 'error.main', display: 'block', textAlign: 'center' }}>
                                {String(fetchNoticiasGETData.error?.message || fetchNoticiasGETData.error)}
                            </Typography>
                        }

                        <Box sx={{ display: 'grid', gap: 1 }}>

                            {
                                noticias.map((noticia: any) => (
                                    <Paper key={noticia.id} variant="outlined" className='p-2' sx={{ borderRadius: 2 }}>

                                        {
                                            noticia.imagen &&
                                            <Box
                                                component="img"
                                                src={noticia.imagen}
                                                alt={noticia.titulo}
                                                sx={{
                                                    width: '100%',
                                                    height: 220,
                                                    objectFit: 'contain',
                                                    bgcolor: 'grey.100',
                                                    borderRadius: 1.5,
                                                    mb: 1.5,
                                                    display: 'block',
                                                }}
                                            />
                                        }

                                        <Typography variant='subtitle2' className='fw-500 my-0' sx={{ wordBreak: 'break-word' }}>
                                            {noticia.titulo}
                                        </Typography>

                                        <Typography variant='caption' className='my-0' sx={{ color: 'text.secondary' }}>
                                            {noticia.fecha}
                                        </Typography>

                                        <Typography
                                            variant='body2'
                                            className='my-1'
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {noticia.resumen}
                                        </Typography>

                                        <Box sx={{ textAlign: 'right' }}>
                                            <Button
                                                size="small"
                                                color="primary"
                                                variant="text"
                                                startIcon={<FontAwesomeIcon icon={faEye} />}
                                                onClick={() => handleVerNoticia(noticia)}
                                            >
                                                {Lang('VEURE_NOTICIA')}
                                            </Button>
                                        </Box>

                                    </Paper>
                                ))
                            }

                            {
                                fetchNoticiasGETData.loading === false && !fetchNoticiasGETData.error && noticias.length === 0 &&
                                <Typography variant='body2' className='my-0' sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                                    {Lang('SENSE_NOTICIES')}
                                </Typography>
                            }

                        </Box>

                        {
                            fetchNoticiasGETData.loading !== null && (noticias.length > 0 || fetchNoticiasGETData.loading === true) &&
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, flexWrap: 'wrap', gap: 1 }}>
                                <Typography variant='caption' className='my-0' sx={{ color: 'text.secondary' }}>
                                    {paginacionNoticiasView.page} de {paginacionNoticiasView.last_page}
                                </Typography>
                                {
                                    paginacionNoticiasView.last_page > 1 &&
                                    <Pagination
                                        page={paginacionNoticiasView.page}
                                        count={paginacionNoticiasView.last_page}
                                        onChange={handleCambioPaginaNoticias}
                                        color="primary"
                                        size="small"
                                    />
                                }
                            </Box>
                        }

                    </Paper>
                </Grid>

            </Grid>

            {/* -------------------- Modals -------------------- */}

            <ModalNoticia
                noticia={noticiaSeleccionada}
                detalle={fetchNoticiaGETData.data?.data}
                cargando={!!fetchNoticiaGETData.loading}
                onClose={handleCerrarNoticia}
            />

            <ModalActividad
                actividad={actividadSeleccionada}
                detalle={fetchActividadGETData.data?.data}
                inscritos={fetchActividadGETData.data?.inscritos || []}
                cargando={!!fetchActividadGETData.loading}
                onClose={handleCerrarActividad}
                personas={fetchPersonasGETData.data?.items || []}
                personasCargando={!!fetchPersonasGETData.loading}
                personasError={fetchPersonasGETData.error}
                personasPaginacion={{
                    page: fetchPersonasGETData.data?.numeroPagina != null ? fetchPersonasGETData.data.numeroPagina + 1 : personasPage,
                    last_page: fetchPersonasGETData.data?.totalPages || 1,
                }}
                onPersonasPageChange={handleCambioPaginaPersonas}
                onPersonasBuscar={handleBuscarPersonas}
                checkedPersonas={checkedPersonas}
                onTogglePersona={handleTogglePersona}
                personasMarcadas={personasMarcadas}
                onInscribir={handleInscribirPersonas}
                inscribiendo={!!fetchInscribirPOSTData.loading}
                onAnularInscripcion={handleAnularInscripcion}
                anulando={!!fetchAnularPOSTData.loading}
            />

            <ModalStatusServer
                fetchData={fetchInscribirPOSTData}
                activeLoading
                messageStatus={
                    {
                        200:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchInscribirPOSTData.data?.message || Lang('PERSONAS_INSCRITAS_OK')}
                                </Typography>
                            </>,
                        201:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchInscribirPOSTData.data?.message || Lang('PERSONAS_INSCRITAS_OK')}
                                </Typography>
                            </>,
                    }
                }
            />

        <ModalStatusServer
                fetchData={fetchAnularPOSTData}
                activeLoading
                messageStatus={
                    {
                        200:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchAnularPOSTData.data?.message || Lang('INSCRIPCION_ANULADA_OK')}
                                </Typography>
                            </>,
                        201:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchAnularPOSTData.data?.message || Lang('INSCRIPCION_ANULADA_OK')}
                                </Typography>
                            </>,
                    }
                }
            />

        </div>
    )
}